'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = require('libphonenumber-js/core');

Object.defineProperty(exports, 'parseRFC3966', {
  enumerable: true,
  get: function get() {
    return _core.parseRFC3966;
  }
});
Object.defineProperty(exports, 'formatRFC3966', {
  enumerable: true,
  get: function get() {
    return _core.formatRFC3966;
  }
});
//# sourceMappingURL=RFC3966.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/modules/libphonenumber/RFC3966.js
// module id = 697
// module chunks = 2